<template>
  <div class="component-card">
    <j-title-header :options="title"/>

    <b-row>
      <b-col md="6">
        <b-form-group :class="{'error-input' : $v.buku_saku.tahun_ajaran.$error}">
          <label> Tahun Ajaran </label>
          <j-single-select
            v-model="$v.buku_saku.tahun_ajaran.$model"
            :options="list_tahun_ajaran"
            :placeholder="'Select Tahun Ajaran'"
            value-format="object"
            label="tahunajaran"
            @getData="getDataKelas"/>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :class="{'error-input' : $v.buku_saku.kelas.$error}">
          <label> Kelas </label>
          <j-single-select
            v-model="$v.buku_saku.kelas.$model"
            :options="list_kelas"
            :placeholder="'Select Kelas'"
            :disabled="!buku_saku.tahun_ajaran"
            value-format="object"
            label="name"/>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div class="float-to-right m__t--20">
          <b-button
            :disabled="!buku_saku.tahun_ajaran || !buku_saku.kelas"
            class="btn blue"
            @click="cariSiswa">
            Cari
          </b-button>
        </div>
      </b-col>
    </b-row>

    <v-client-table
      v-if="list_siswa.length > 0"
      :data="list_siswa"
      :columns="columns"
      :options="options"
      class="jTable"
      @row-click="openEdit"/>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';

export default {
  components: {
  },
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Buku Saku Siswa',
      },
      buku_saku: {
        tahun_ajaran: null,
        kelas: null,
      },
      list_tahun_ajaran: [],
      list_kelas: [],
      list_siswa: [],
      columns: ['nis', 'name', 'total_point_pelanggaran'],
      options: {
        headings: {
          nis: 'NIS',
          name: 'Nama',
          total_point_pelanggaran: 'TOTAL POIN PELANGGARAN',
        },
        sortIcon: { base: 'fa', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort' },
        sortable: [],
        filterable: false,
      },
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
    const params = {
      pagination: {
        query: '',
        query_type: '',
      },
    };
    this.getListTahunAjaran(params).then((res) => {
      this.list_tahun_ajaran = res.data.data;
    });
  },
  methods: {
    ...mapActions('jStoreKesiswaan', ['getListTahunAjaran', 'getListKelas', 'getListSiswaByKelas']),

    getDataKelas() {
      const params = {
        pagination: {
          query: this.buku_saku.tahun_ajaran.tahunajaran,
          query_type: 'tahunajaran',
        },
      };
      this.getListKelas(params).then((res) => {
        this.list_kelas = res.data.data;
      });
    },

    cariSiswa() {
      const params = {
        kode_kelas: this.buku_saku.kelas.kode,
        tahunajaran: this.buku_saku.tahun_ajaran.tahunajaran,
      };
      this.getListSiswaByKelas(params).then((res) => {
        this.list_siswa = res.data.data;
      });
    },

    openEdit(param) {
      const tahunAjaran = this.buku_saku.tahun_ajaran.tahunajaran.replace('/', '-');
      this.$router.replace(`/buku-saku-siswa/detail/${tahunAjaran}/${this.buku_saku.kelas.kode}/${param.row.nis}`);
    },
  },
  validations() {
    return {
      buku_saku: {
        tahun_ajaran: { required },
        kelas: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kesiswaan/buku-saku/jBukuSaku.vue